import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { forwardRef } from 'react';
const Fab = forwardRef(({ 'aria-label': ariaLabel, children, className, disabled, id, onClick, onKeyDown, type = 'button', variant, ...rest }, ref) => {
    return (_jsx("button", { "aria-label": ariaLabel, className: buildClassName('hover:bg-primary-blue/10 bg-gray elevation-1 disabled:hover:bg-gray border-none p-3 leading-[0] text-[#666666] hover:cursor-pointer disabled:cursor-default disabled:text-[rgba(102,102,102,0.2)]', {
            'rounded-full': variant === 'circle',
            'rounded-lg': variant === 'square',
        }, className), disabled: disabled, id: id, onClick: onClick, onKeyDown: onKeyDown, ref: ref, type: type, ...rest, children: children }));
});
export default Fab;
//# sourceMappingURL=Fab.js.map